import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { MissionsPageEmptyState } from './MissionsPageEmptyState';
import { Section } from './Section';

const Root = styled(Vertical).attrs({ gap: 4 })`
  padding: var(--double-unit) 0;
`;

type Section = {
  id: string;
  show?: boolean;
  title?: ReactNode;
  subtitle?: ReactNode;
  content?: ReactNode;
  expandedByDefault?: boolean;
};
type Props = {
  sections: Section[];
};
export const MissionsPage = ({
  sections,
  children,
}: PropsWithChildren<Props>) => {
  const sectionToShow = sections.some(
    ({ id, show }) => !!show && id !== 'claimed'
  );
  const claimedSection = sections.find(({ id }) => id === 'claimed');

  return (
    <Root>
      {sectionToShow ? (
        sections.map(
          ({ id, show, title, subtitle, content, expandedByDefault }) =>
            show && (
              <Section
                key={id}
                subtitle={subtitle}
                title={title}
                expandedByDefault={expandedByDefault}
              >
                {content}
              </Section>
            )
        )
      ) : (
        <>
          <MissionsPageEmptyState hasClaimedTask={claimedSection?.show} />
          {Array.isArray(claimedSection?.content) &&
            !!claimedSection?.content.length && (
              <Section
                subtitle={claimedSection.subtitle}
                title={claimedSection.title}
                expandedByDefault
              >
                {claimedSection.content}
              </Section>
            )}
        </>
      )}
      {children}
    </Root>
  );
};
